var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1705781198752"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1250,2500L1250,2500c688,0,1250-563,1250-1250l0,0C2500,562,1937,0,1250,0l0,0C562,0,0,563,0,1250l0,0    C0,1938,563,2500,1250,2500z",
    style: {
      fill: "#8247E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1612,1520l354-204c19-11,30-31,30-53V855c0-22-12-42-30-53l-354-204c-19-11-42-11-61,0l-354,204    c-19,11-30,31-30,53v730l-248,143l-248-143v-286l248-143l164,94v-192l-133-77c-9-5-20-8-30-8c-11,0-21,3-30,8l-354,204    c-19,11-30,31-30,53v408c0,22,12,42,30,53l354,204c19,11,42,11,61,0l354-204c19-11,30-31,30-53V916l4-3l244-141l248,143v286    l-248,143l-163-94v192l133,77c19,11,42,11,61,0l0,0L1612,1520z",
    style: {
      fill: "#FFFFFF"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.8c981eb4164405d8bbd60ddf4feb3812.svg";
export { ForwardRef as ReactComponent };